<template>
  <div
    v-show="scene.show"
    class="tool-play-scene"
    :style="sceneStyle"
  >
    <div
      class="tool-scene-camera"
      :style="cameraStyle"
    >
      <play-scene-bg
        :bg="scene.background"
        :frame="scene.frame"
        @loadDone="loadDone"
      ></play-scene-bg>
      <editor-play-sprite
        v-for="(sprite, k) in sprites"
        :key="k"
        :sprite="sprite"
        @loadDone="loadDone"
      ></editor-play-sprite>
    </div> 
  </div>
</template>
<script>
import EditorPlaySprite from './editorPlaySprite'
import PlaySceneBg from './playSceneBg.vue'

export default {
  name: 'EditorPlayScene',
  components: {
    EditorPlaySprite,
    PlaySceneBg
  },
  props: {
    scene: {
      type: Object,
      required: true
    }
  },
  data(){
    return{
      sprites: [],
      camera: {
        scale: 1,
        top: 0,
        left: 0
      },
      loadNum: 0
    };
  },
  computed: {
    sceneStyle() {
      const style = {};
      style.zIndex = this.scene.zIndex;
      style.transform = this.scene.transform;
      style.opacity = this.scene.opacity;
      style.clipPath = this.scene.clipPath;
      style.transformOrigin = this.scene.transformOrigin;
      style.transformStyle = this.scene.transformStyle;
      style.filter = this.scene.filter;
      return style;
    },
    cameraStyle() {
      const style = {};
      style.transform = `translate(${this.camera.left}px, ${this.camera.top}px) scale(${this.camera.scale})`;
      return style;
    }
  },
  mounted(){
    this.sprites = this.scene.sprites;
    this.camera = this.scene.camera;
  },
  methods: {
    loadDone(){
      // this.loadNum++;
      // if(this.loadNum >= this.scene.loadLength) {
        // 获取场景页缩略图并
        // let dom = this.scene.getThumbDom(Math.floor(this.scene.duration / 2 * 60));
        // dom.style.transform = 'scale(0.036)';
        // dom.style.transformOrigin = '0 0';
      // }
      this.$emit('loadDone');
    }
  }
};
</script>
<style lang="scss">
.tool-play-scene {
  position: absolute;
  top: 0;
  left: 0;
  width: 1920px;
  height: 1080px;
  overflow: hidden;
  transition: transform 0ms linear;
  filter: none;
}
.tool-scene-camera {
  width: 100%;
  height: 100%;
  position: absolute;
  transform-origin: top left;
  transition: transform 0ms linear;
}
</style>


// WEBPACK FOOTER //
// src/components/draftPreview/editorPlayScene.vue